import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/Modal/index'
import Button from 'component/Button/index'
import TextField from '../TextField'
import Radio from '../Radio'
import Checkbox from '../Checkbox/newCheckbox'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelectNew'
import HierarchySelect from 'component/hierarchy/HierarchySelectNew'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import Mask from 'vanilla-masker'
import moment from 'moment'

class FormModal extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    edit: PropTypes.object,
    toggleEdit: PropTypes.func,
  }

  state = {
    values: {
      idInventoryCriteria: '',
      dsListName: '',
      listRegionsAndBranchs: [],
      cdSection: '',
      cdSubSection: '',
      cdItem: '',
      cdSubItem: '',
      qtItemsInList: '',
      validity: [],
      criteria: '',
      vlProductsAbove: '',
      qtDaysNoSale: '',
      inTopZero: 0,
      inTopOne: 0,
      inTopTwo: 0,
    },
    allBranchOptions: [],
  }

  componentDidMount() {
    const { edit } = this.props

    if (edit) {
      this.fetchList(edit.idInventoryCriteria)
    }
  }

  resetForm = () => {
    this.setState({
      values: {
        idInventoryCriteria: '',
        dsListName: '',
        listRegionsAndBranchs: [],
        cdSection: '',
        cdSubSection: '',
        cdItem: '',
        cdSubItem: '',
        qtItemsInList: '',
        validity: [],
        criteria: '',
        vlProductsAbove: '',
        qtDaysNoSale: '',
        inTopZero: 0,
        inTopOne: 0,
        inTopTwo: 0,
      },
      allBranchOptions: [],
    })
  }

  fetchList = async (idInventoryCriteria) => {
    const { user, toggleEdit } = this.props

    if (user) {
      this.setState({ loading: true })
      const query = { idInventoryCriteria }

      try {
        const { data } = await new Api(user.dsToken).get(
          API_URL.INVENTORY_CRITERIA_FETCH_ID,
          query
        )
        this.fillFields(data)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
        toggleEdit(false)
      } finally {
        this.setState({ loading: false })
      }
    }
  }

  fillFields(list) {
    const { values } = this.state

    list.listRegionsAndBranchs.forEach((l) => {
      l.value = l.idBranchOrRegion
      l.isBranch = 1
    })

    values.dsListName = list.dsListName
    values.listRegionsAndBranchs = list.listRegionsAndBranchs
    values.idInventoryCriteria = list.idInventoryCriteria
    values.cdSection = list.cdSection
    values.cdSubSection = list.cdSubSection
    values.cdItem = list.cdItem
    values.cdSubItem = list.cdSubItem

    if (list.inProductsVlAbove) {
      values.criteria = 'inProductsVlAbove'
    } else if (list.inProductsAvs) {
      values.criteria = 'inProductsAvs'
    } else if (list.inProductsStockNeg) {
      values.criteria = 'inProductsStockNeg'
    } else if (list.inItemsNoSale) {
      values.criteria = 'inItemsNoSale'
    }

    values.vlProductsAbove = this.getMoneyValue(list.vlProductsAbove)
    values.qtDaysNoSale = list.qtDaysNoSale
    values.inProductsList = list.inProductsList
    values.listProducts = list.listProducts
    values.inTopZero = list.inTopZero
    values.inTopOne = list.inTopOne
    values.inTopTwo = list.inTopTwo
    values.qtItemsInList = list.qtItemsInList
    values.validity = [moment(list.dtBegin), moment(list.dtEnd)]

    this.setState({ values })
  }

  getMoneyValue = (value) => {
    const isWholeNumber = value % 1 === 0
    return Mask.toMoney(isWholeNumber ? `${value}.00` : value || 0)
  }

  handleChange = (name, value) => {
    const { values } = this.state

    values[name] = value

    const hierarchyFields = ['cdSection', 'cdSubSection', 'cdItem', 'cdSubItem']
    if (hierarchyFields.indexOf(name) !== -1) {
      const index = hierarchyFields.indexOf(name)
      for (let i = index + 1; i <= hierarchyFields.length - 1; i++) {
        values[hierarchyFields[i]] = ''
      }
    }

    this.setState({ values })
  }

  isBtnDisabled() {
    const { edit } = this.props
    const { values } = this.state
    let disabled = false

    const toValidate = [
      'dsListName',
      'validity',
      'listRegionsAndBranchs',
      'qtItemsInList',
      'cdSection',
      'criteria',
    ]

    for (const field of toValidate) {
      if (
        (Array.isArray(values[field]) && values[field].length === 0) ||
        !values[field]
      ) {
        disabled = true
      }
    }

    if (values.criteria === 'inProductsVlAbove' && !values.vlProductsAbove) {
      disabled = true
    }

    if (values.criteria === 'inItemsNoSale' && !values.qtDaysNoSale) {
      disabled = true
    }

    if (!edit && !values.inTopZero && !values.inTopOne && !values.inTopTwo) {
      disabled = true
    }

    return disabled
  }

  onSubmit = () => {
    const { toggleEdit, onSubmit, edit } = this.props

    const { values } = this.state

    values.dtBegin = values.validity[0].format()
    values.dtEnd = values.validity[1].format()

    const { allBranchOptions } = this.state
    const expandedBranches = []
    
    values.listRegionsAndBranchs.forEach((item) => {
      if (item.isBranch === true || item.isBranch === 1) {
        expandedBranches.push(item)
      } else if (item.idBranches && Array.isArray(item.idBranches)) {
        item.idBranches.forEach((branchId) => {
          const branchOption = allBranchOptions.find(
            opt => opt.isBranch && opt.value === branchId
          )
          
          expandedBranches.push({
            value: branchId,
            idBranchOrRegion: branchId,
            dsBranchOrRegion: branchOption ? branchOption.label : branchId,
            isBranch: 1,
            idRegion: item.value
          })
        })
      }
    })

    values.listRegionsAndBranchs = expandedBranches

    const criterias = [
      'inProductsVlAbove',
      'inProductsAvs',
      'inProductsStockNeg',
      'inItemsNoSale',
    ]

    for (const c of criterias) {
      values[c] = values.criteria === c ? 1 : 0
    }

    if (!edit) {
      this.resetForm()
    }

    if (toggleEdit) {
      toggleEdit(false)
    }

    onSubmit(values)
  }

  render() {
    const { translate, user, edit, toggleEdit = () => {} } = this.props

    const { values } = this.state

    return (
      <Modal
        className='irc-form-modal'
        title={translate('irc.form.title')}
        buttonText={!edit ? translate('irc.new-button') : false}
        cancelButtonText={translate('close')}
        confirmButtonText={translate('register_button')}
        disabledBgClickClosing
        isConfirmButtonDisabled={this.isBtnDisabled()}
        isOpen={Boolean(edit)}
        onConfirm={this.onSubmit}
        onCloseModal={() => toggleEdit(false)}
        renderButton={
          !edit
            ? ({ onClick, buttonText }) => (
                <Button
                  className='btn btn-primary margin-right'
                  text={buttonText}
                  onClick={onClick}
                />
              )
            : false
        }
      >
        <form action='#' onSubmit={(e) => e.preventDefault()} className='w-100'>
          <div className='w-100'>
            <TextField
              required
              label={translate('irc.name')}
              placeholder={translate('irc.choose-name')}
              name={'dsListName'}
              fill
              onChange={(e) => this.handleChange('dsListName', e.target.value)}
              translate={translate}
              value={values.dsListName}
              validateValue={(v) => Boolean(v)}
            />
          </div>

          <div className='w-100'>
            <RegionBranchMultipleSelect
              required
              name='listRegionsAndBranchs'
              label={translate('irc.store')}
              placeholder={translate('irc.choose-store')}
              user={user}
              translate={translate}
              onChange={(e) =>
                this.handleChange('listRegionsAndBranchs', e.target.value)
              }
              value={values.listRegionsAndBranchs}
              getAllBranchs={(options) => {
                this.setState({ allBranchOptions: options })
              }}
              excludeInactive={true}
            />
          </div>

          <div className='w-100'>
            <HierarchySelect
              required
              label={translate('irc.section')}
              placeholder={translate('irc.choose-section')}
              name={'cdSection'}
              query={{ level: 2 }}
              user={user}
              translate={translate}
              value={values.cdSection}
              fill
              onChange={(e) => this.handleChange('cdSection', e.value)}
              field='sectionId'
              clearButton
            />
          </div>

          {values.cdSection && (
            <div className='w-100'>
              <HierarchySelect
                label={translate('irc.sub-section')}
                placeholder={translate('irc.choose-sub-section')}
                name={'cdSubSection'}
                query={{ level: 3, sectionId: values.cdSection }}
                user={user}
                translate={translate}
                value={values.cdSubSection}
                fill
                onChange={(e) => this.handleChange('cdSubSection', e.value)}
                field='subSectionId'
                clearButton
              />
            </div>
          )}

          {values.cdSubSection && (
            <div className='w-100'>
              <HierarchySelect
                label={translate('irc.tip')}
                placeholder={translate('irc.choose-tip')}
                name={'cdItem'}
                query={{
                  level: 4,
                  sectionId: values.cdSection,
                  subSectionId: values.cdSubSection,
                }}
                user={user}
                translate={translate}
                value={values.cdItem}
                fill
                onChange={(e) => this.handleChange('cdItem', e.value)}
                field='typeId'
                clearButton
              />
            </div>
          )}

          {values.cdItem && (
            <div className='w-100'>
              <HierarchySelect
                label={translate('irc.sub-tip')}
                placeholder={translate('irc.choose-sub-tip')}
                name={'cdSubItem'}
                query={{
                  level: 5,
                  sectionId: values.cdSection,
                  subSectionId: values.cdSubSection,
                  typeId: values.cdItem,
                }}
                user={user}
                translate={translate}
                value={values.cdSubItem}
                field='subTypeId'
                fill
                onChange={(e) => this.handleChange('cdSubItem', e.value)}
                clearButton
              />
            </div>
          )}

          <div className='w-100'>
            <TextField
              required
              label={translate('irc.qt-items-in-list')}
              placeholder={translate('irc.choose-qt-items-in-list')}
              name={'qtItemsInList'}
              fill
              onChange={(e) =>
                this.handleChange('qtItemsInList', e.target.value)
              }
              mask={'99999999'}
              translate={translate}
              value={values.qtItemsInList}
              validateValue={(v) => v && v.length > 0}
            />
          </div>

          <div className='w-100'>
            <NewDateIntervalInput
              label={translate('irc.validity')}
              required
              initialValue={
                values.validity.length > 0 ? values.validity : false
              }
              name={'validity'}
              t={translate}
              onChange={(e) => this.handleChange('validity', e)}
              noSelect
              disableAutoClose
              minDate={
                edit && values.validity.length > 0
                  ? values.validity[0].toDate()
                  : new Date()
              }
            />
          </div>

          <div className='w-100 margin-top-double'>
            <h4 className='margin-top margin-bottom'>
              <b>{translate('irc.counting-criteria')}</b>
            </h4>
            <div className='radios'>
              <div className='w-100'>
                <Radio
                  label={translate('irc.products-value-above')}
                  value={'inProductsVlAbove'}
                  name={'criteria'}
                  onChange={(e) =>
                    this.handleChange('criteria', e.target.value)
                  }
                  checked={values.criteria === 'inProductsVlAbove'}
                />
                <input
                  name='vlProductsAbove'
                  className={`form-control ${
                    values.vlProductsAbove ? 'filled' : ''
                  }`}
                  disabled={values.criteria !== 'inProductsVlAbove'}
                  onChange={(e) =>
                    this.handleChange(
                      'vlProductsAbove',
                      Mask.toMoney(e.target.value)
                    )
                  }
                  value={values.vlProductsAbove}
                />
              </div>
              <div className='w-100'>
                <Radio
                  label={translate('irc.avs-products')}
                  value={'inProductsAvs'}
                  name={'criteria'}
                  onChange={(e) =>
                    this.handleChange('criteria', e.target.value)
                  }
                  checked={values.criteria === 'inProductsAvs'}
                />
              </div>
              <div className='w-100'>
                <Radio
                  label={translate('irc.negative-stock-products')}
                  value={'inProductsStockNeg'}
                  name={'criteria'}
                  onChange={(e) =>
                    this.handleChange('criteria', e.target.value)
                  }
                  checked={values.criteria === 'inProductsStockNeg'}
                />
              </div>
              <div className='w-100'>
                <Radio
                  label={translate('irc.days-no-sale-items-1')}
                  value={'inItemsNoSale'}
                  id={'inItemsNoSale'}
                  name={'criteria'}
                  onChange={(e) =>
                    this.handleChange('criteria', e.target.value)
                  }
                  checked={values.criteria === 'inItemsNoSale'}
                />
                <input
                  type='number'
                  name='qtDaysNoSale'
                  className={`form-control ${
                    values.qtDaysNoSale ? 'filled' : ''
                  }`}
                  disabled={values.criteria !== 'inItemsNoSale'}
                  onChange={(e) =>
                    this.handleChange('qtDaysNoSale', e.target.value)
                  }
                  value={values.qtDaysNoSale}
                />
                <label
                  htmlFor={'inItemsNoSale'}
                  className={`second-label ${
                    values.criteria === 'inItemsNoSale' ? 'on' : ''
                  }`}
                >
                  {translate('irc.days-no-sale-items-2')}
                </label>
              </div>
            </div>
          </div>

          <div className='w-100 checkboxs margin-top-double'>
            <div className='part'>
              <Checkbox
                label={translate('irc.labelTop0')}
                name={'inTopZero'}
                onChange={(e) => this.handleChange('inTopZero', e ? 1 : 0)}
                checked={Boolean(values.inTopZero)}
              />
            </div>
            <div className='part'>
              <Checkbox
                label={translate('irc.labelTop1')}
                name={'inTopOne'}
                onChange={(e) => this.handleChange('inTopOne', e ? 1 : 0)}
                checked={Boolean(values.inTopOne)}
              />
            </div>
            <div className='part'>
              <Checkbox
                label={translate('irc.labelTop2')}
                name={'inTopTwo'}
                onChange={(e) => this.handleChange('inTopTwo', e ? 1 : 0)}
                checked={Boolean(values.inTopTwo)}
              />
            </div>
          </div>
        </form>
      </Modal>
    )
  }
}

export default FormModal
export { FormModal }
